import { sortCaret } from "../../../../../_metronic/_helpers";

export const defaultSorted = [{ dataField: "id", order: "asc" }];
export const sizePerPageList = [
  { text: "10", page: 10 },
  { text: "25", page: 25 },
  { text: "50", page: 50 },
  { text: "100", page: 100 }
];
export const initialFilter = {
  filter: {},
  sortOrder: "asc", // asc||desc
  sortField: "grade",
  pageNumber: 1,
  pageSize: 10
};
// Initial Table columns
export const initialColumns = [
  {
    dataField: "gradeLevelName",
    text: "Sınıf Düzeyi",
    sort: true,
    width: 15,
    sortCaret: sortCaret,
  },
  {
    dataField: "grade",
    text: "Sınıf",
    sort: true,
    width: 15,
    sortCaret: sortCaret,
  },    
  {
    dataField: "name",
    text: "Şube",
    sort: true,
    width: 20,
    sortCaret: sortCaret,
  },
  {
    dataField: "capacity",
    text: "Kapasite",
    sort: true,
    width: 15,
    sortCaret: sortCaret,
  },
  {
    dataField: "maleStudentCount",
    text: "Erkek",
    sort: true,
    width: 15,
    sortCaret: sortCaret,
  },
  {
    dataField: "femaleStudentCount",
    text: "Kız",
    sort: true,
    width: 15,
    sortCaret: sortCaret,
  },
  {
    dataField: "reRegistratedStudentCount",
    text: "Kayıt Yenileme",
    sort: true,
    width: 15,
    sortCaret: sortCaret,
  },
  {
    dataField: "newRegistratedStudentCount",
    text: "Yeni Kayıt",
    sort: true,
    width: 15,
    sortCaret: sortCaret,
  },
  {
    dataField: "totalStudentCount",
    text: "Toplam",
    sort: true,
    width: 15,
    sortCaret: sortCaret,
  },
  {
    hidden: true
  }
];